module.exports = __webpack_public_path__ + "static/media/drink.0cd41dd6.svg";